import React, { Fragment, useEffect, useState } from 'react';
import ReactECharts from 'echarts-for-react';
import { graphColors } from '../../helpers/meta';

const getOptions = (title = '', data, legends) => {
    return {
        tooltip: {
            trigger: 'item'
        },
        legend: {
            show: legends,
            top: '5%',
            left: 'center'
        },
        color: graphColors,
        grid: {
            left: 0,
            top: 0,
            right: 0,
            bottom: 0
        },
        series: [
            {
                name: title,
                type: 'pie',
                radius: ['70%', '80%'],
                avoidLabelOverlap: false,
                itemStyle: {
                    borderRadius: 0,
                    borderColor: '#fff',
                    borderWidth: 1
                },
                label: {
                    show: false,
                    position: 'center'
                },
                emphasis: {
                    scale: false
                },
                labelLine: {
                    show: false
                },
                data: data
                
            }
        ]
    };
}

const PieCore = ({title = '', data, legends}) => {

    const [option, setOption] = useState(null);
    useEffect(()=>{
        setOption(getOptions(title, data, legends));
    }, [data])

    return (
        <Fragment>
            { option != undefined &&
                <ReactECharts
                    option={option}
                    style={{ height: 150 }}
                />
            }
        </Fragment>
    )
}

export default PieCore;